// extracted by mini-css-extract-plugin
export var borderRadius = "_9p-4";
export var large = "_9p-3";
export var logoContainer = "_9p-0";
export var nameLogo = "_9p-2";
export var small = "_9p-1";